module.exports = __webpack_public_path__ + "b91576f804bc48173034451371f4f921.svg";